import React, { useState, useEffect } from 'react';
import StreamTab from './tabs/StreamTab';
import PeopleTab from './tabs/PeopleTab';
import ClassworkTab from './tabs/ClassworkTab';
import { getClassroomDetails } from '../../services/ClassroomService.ts';
import '../../css/Classroom.css';

const TeacherDashboard = () => {
  const [activeTab, setActiveTab] = useState('stream');
  const [classroomDetails, setClassroomDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const details = await getClassroomDetails();
        setClassroomDetails(details);
      } catch (error) {
        console.error("Failed to fetch classroom details", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, []);

  const renderTabContent = () => {
    if (loading) {
      return <div>Loading classroom data...</div>;
    }
    if (!classroomDetails) {
      return <div>Could not load classroom data.</div>;
    }

    switch (activeTab) {
      case 'stream':
        return <StreamTab classroomDetails={classroomDetails} />;
      case 'people':
        return <PeopleTab classroomDetails={classroomDetails} />;
      case 'classwork':
        return <ClassworkTab classroomDetails={classroomDetails} />;
      default:
        return <StreamTab classroomDetails={classroomDetails} />;
    }
  };

  return (
    <div className="teacher-dashboard">
      <div className="dashboard-tabs">
        <span onClick={() => setActiveTab('stream')} className={activeTab === 'stream' ? 'active' : ''}>Stream</span>
        <span onClick={() => setActiveTab('people')} className={activeTab === 'people' ? 'active' : ''}>People</span>
        <span onClick={() => setActiveTab('classwork')} className={activeTab === 'classwork' ? 'active' : ''}>Classwork</span>
      </div>
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default TeacherDashboard;